import config from '../config';

const name = 'zender-live-studio';

class ZenderLogger {
	constructor() {
		this.logAll = true;
		this.logUserids = {};
		this.ctx = {
			sessionId: Math.random().toString(36).substring(2, 10),
			name,
		};
		this.logUrl = config.logUrl;
		/* eslint-disable no-console */
		this.oldConsole = {
			log: console.log.bind(console),
			info: console.info.bind(console),
			warn: console.warn.bind(console),
			error: console.error.bind(console),
		};
		/* eslint-enable no-console */
		// const hijackLog = (...args) => {
		// 	if (!args[0]) {
		// 		return;
		// 	}
		// 	if (typeof args[0] === 'string' && args[0].startsWith('Sending "zender:')) {
		// 		// ignore stuff sent over the bridge
		// 		return;
		// 	}
		// 	this.debug({ tag: 'highjack', args });
		// };
		// console.log = hijackLog;
		// console.info = hijackLog;
		// console.warn = hijackLog;
		// console.error = hijackLog;
		window.onerror = (...msg) => {
			this.warn({ tag: 'window.onerror', msg });
			return true;
		};
		window.onabort = (...msg) => {
			this.warn({ tag: 'window.onabort', msg });
			return true;
		};
		window.addEventListener('error', (evt) => {
			this.warn({ tag: 'window.errorevent', msg: evt });
			evt.preventDefault();
		});
	}

	log(...message) {
		this.oldConsole.log(...message);
		const logObject = this.getLogObject(message);
		if (logObject) {
			logObject.level = 20;
			this.logToLogservice(logObject);
		}
	}

	info(...message) {
		this.oldConsole.info(...message);
		const logObject = this.getLogObject(message);
		if (logObject) {
			logObject.level = 30;
			this.logToLogservice(logObject);
		}
	}

	warn(...message) {
		this.oldConsole.warn(...message);
		const logObject = this.getLogObject(message);
		if (logObject) {
			logObject.level = 40;
			this.logToLogservice(logObject);
		}
	}

	error(...message) {
		this.oldConsole.error(...message);
		const logObject = this.getLogObject(message);
		if (logObject) {
			logObject.level = 50;
			this.logToLogservice(logObject);
		}
	}

	debug(...message) {
		// TODO if local ofzo maar niet staging
		this.oldConsole.log(...message);
		const logObject = this.getLogObject(message);
		if (logObject) {
			logObject.level = 10;
			this.logToLogservice(logObject);
		}
	}

	addContext(ctx) {
		Object.assign(this.ctx, ctx);
	}

	logForUserids(arg) {
		this.logAll = false;
		this.logUserids = {};
		if (arg === 'ALL') {
			this.logAll = true;
		} else {
			const userids = JSON.parse(arg);
			if (typeof userids === 'object') {
				Object.keys(userids).forEach((userId) => {
					this.logUserids[userId] = true;
				});
			}
		}
	}

	logToLogservice(message) {
		console.log('### logToLogservice ###>', this.logUrl);
		if (!this.logUrl) {
			return;
		}
		const str = this.asString(message);
		if (!str) {
			return;
		}
		// note: 8192 is the limit for logentries, but let's keep it this way for other logservices too
		if (str.length > 8192) {
			this.oldConsole.info('Too long to send to logservice', message);
			return;
		}
		if (message && message.level && message.level < 30) {
			// don't transmit debug messages
			return;
		}
		const request = new XMLHttpRequest(); // eslint-disable-line no-undef
		request.open('POST', this.logUrl);
		request.setRequestHeader('Content-Type', 'application/json');
		request.send(str);
	}

	getLogObject(message) {
		if (!this.logAll && !this.logUserids[this.ctx.userId]) {
			return undefined;
		}
		if (message.length > 1) {
			this.oldConsole.error('Only log objects plz', message);
			return undefined;
		}
		return { ...this.ctx, msg: message[0], localTime: new Date().toISOString() };
	}

	asString = (message) => {
		try {
			return JSON.stringify(message);
		} catch (e) {
			this.oldConsole.info('Could not stringify message:', e, message);
		}
		return undefined;
	}
}

const zenderLogger = new ZenderLogger();

export default zenderLogger;



// WEBPACK FOOTER //
// ./src/log/index.js